import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../config/URL";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { toast } from "react-toastify";
import fetchAllStudentListByCenter from "../List/StudentListByCenter";
import { IoIosEye } from "react-icons/io";
import { MoreVert as MoreVertIcon } from "@mui/icons-material";
import {
  IconButton,
  Menu,
  MenuItem,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { exportVisibleColumnsToCSV } from "../../components/common/ExportCsv";

const Payments = ({ selectedCenter }) => {
  // const storedScreens = JSON.parse(localStorage.getItem("tmsscreens") || "{}");

  const [filters, setFilters] = useState({
    centerId: selectedCenter,
    studentId: "",
    centerId: "",
    paymentDate: "",
    paidAmount: "",
    name: "",
    month: "",
    invoiceNo: "",
    receiptNo: "",
    status: "",
    paymentMethod: "",
    paymentRef: "",
  });

  const [studentData, setStudentData] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedRow(null);
  };
  const storedScreens = JSON.parse(localStorage.getItem("screens") || {});

  const canRead = Boolean(storedScreens?.paymentRead);
  const canCreate = Boolean(storedScreens?.paymentCreate);

  console.log("Role is ", canCreate);

  const canUpdate = Boolean(storedScreens?.paymentUpdate);

  const showActionColumn = canUpdate;

  /* -------------------- COLUMNS -------------------- */
  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorFn: (row, index) => index + 1,
        header: "S.NO",
        size: 40,
        Cell: ({ cell }) => (
          <span style={{ textAlign: "center" }}>{cell.getValue()}</span>
        ),
      },
      {
        accessorKey: "invoices",
        header: "Invoice No.",
        Cell: ({ row }) => {
          const invoices = row.original.invoices || [];
          return invoices.length ? (
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              {invoices.map((inv, i) => (
                <li
                  key={i}
                  style={{ color: "blue", cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/invoice/view/${inv.invoiceId}`);
                  }}
                >
                  {inv.invoiceNumber}
                </li>
              ))}
            </ul>
          ) : (
            "N/A"
          );
        },
      },
      {
        accessorKey: "file",
        header: "PayNow",
        Cell: ({ row }) =>
          row.original.file ? (
            <a
              href={row.original.file}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              style={{ color: "blue" }}
            >
              <IoIosEye className="fs-5" />
            </a>
          ) : (
            "-"
          ),
      },
      {
        accessorKey: "receiptNo",
        header: "Receipt No.",
        Cell: ({ row }) => (
          <span
            style={{ color: "blue", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/receiptView/${row.original.receipt?.[0]?.id}`);
            }}
          >
            {row.original.receiptNo || ""}
          </span>
        ),
      },
      { accessorKey: "studentName", header: "Student Name" },
      { accessorKey: "uniqueId", header: "Student ID" },
      {
        accessorKey: "paymentDate",
        header: "Payment Date",
        Cell: ({ cell }) => cell.getValue()?.substring(0, 10) || "",
      },
      { accessorKey: "paymentMethod", header: "Payment Type" },
      { accessorKey: "paymentReference", header: "Payment Ref #" },
      { accessorKey: "paidAmount", header: "Paid Amount" },
      { accessorKey: "creditCardFee", header: "Credit Card Fee" },
    ];

    if (!showActionColumn) return baseColumns;

    const actionColumn = {
      id: "actions",
      header: "",
      size: 20,
      enableSorting: false,
      Cell: ({ row }) => {
        const status = row.original.paymentStatus;
        if (status === "PAID" || status === "CANCELLED") {
          return (
            <span
              className={`badge bg-${
                status === "PAID" ? "success" : "danger"
              } fw-light`}
            >
              {status}
            </span>
          );
        }

        return (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setMenuAnchor(e.currentTarget);
              setSelectedRow(row.original);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        );
      },
    };

    return [baseColumns[0], actionColumn, ...baseColumns.slice(1)];
  }, [showActionColumn]);

  /* -------------------- THEME -------------------- */
  const theme = createTheme({
    components: {
      MuiTableCell: {
        styleOverrides: {
          head: {
            color: "#535454 !important",
            backgroundColor: "#e6edf7 !important",
            fontWeight: "400 !important",
            fontSize: "13px !important",
            textAlign: "center !important",
          },
        },
      },
    },
  });

  /* -------------------- DATA -------------------- */
  const getPaymentData = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams();

      // Ensure centerId is always included
      queryParams.append("centerId", selectedCenter);

      for (let key in filters) {
        if (filters[key] && key !== "centerId") {
          queryParams.append(key, filters[key]);
        }
      }

      const response = await api.get(
        `/paymentByCenterId?${queryParams.toString()}`
      );
      setData(response.data);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchListWithCenterIdData = async () => {
    try {
      const [student] = await Promise.all([
        fetchAllStudentListByCenter(selectedCenter || 0),
      ]);
      setStudentData(student || []);
    } catch (error) {
      toast.error("Failed to fetch data");
      console.error(error);
    }
  };

  useEffect(() => {
    getPaymentData();
    fetchListWithCenterIdData();
  }, [filters, selectedCenter]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
  };
  const clearFilters = () => {
    setFilters({
      centerId: selectedCenter,
      studentId: "",
      centerId: "",
      paymentDate: "",
      paidAmount: "",
      name: "",
      month: "",
      invoiceNo: "",
      receiptNo: "",
      status: "",
      paymentMethod: "",
      paymentRef: "",
    });
    getPaymentData();
  };

  const handleStatusChange = async (newStatus) => {
    if (!selectedRow) return;

    try {
      const response = await api.put(
        `/updatePaymentStatus/${selectedRow.id}?status=${newStatus}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setData((prevData) =>
          prevData.map((item) =>
            item.id === selectedRow.id ? { ...item, status: newStatus } : item
          )
        );
        toast.success(response.data.message);
        handleMenuClose();
        getPaymentData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          `An error occurred while updating to ${newStatus}.`
      );
    }
  };

  const hideColumn =
    storedScreens?.paymentUpdate === false &&
    storedScreens?.paymentDelete === false;

  /* -------------------- MRT INSTANCE -------------------- */
  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnActions: false,
    enableColumnFilters: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 },
      columnVisibility: {
        createdBy: false,
        createdAt: false,
        updatedBy: false,
        updatedAt: false,
        id: !hideColumn,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <button
        className="btn btn-sm btn-border"
        onClick={() =>
          exportVisibleColumnsToCSV(table, data, "PaymentsList.csv")
        }
      >
        Export CSV
      </button>
    ),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: canRead
        ? () => navigate(`/payment/view/${row.original.id}`)
        : undefined,
      style: { cursor: canRead ? "pointer" : "default" },
    }),
  });

  return (
    <div className="container-fluid px-2 my-4 center">
      <ol
        className="breadcrumb my-3"
        style={{ listStyle: "none", padding: 0, margin: 0 }}
      >
        <li>
          <Link to="/" className="custom-breadcrumb">
            Home
          </Link>
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li>
          Invoice and Payment
          <span className="breadcrumb-separator"> &gt; </span>
        </li>
        <li className="breadcrumb-item active" aria-current="page">
          Payment
        </li>
      </ol>
      <div className="card">
        <div
          className="mb-3 d-flex justify-content-between align-items-center p-1"
          style={{ background: "#f5f7f9" }}
        >
          <span className="text-muted">
            This database shows the list of{" "}
            <strong style={{ color: "#287f71" }}>Payment</strong>
          </span>
        </div>
        <div className="mb-3 flex-wrap">
          <div className="row m-0 px-2">
            {/* Filter Fields */}
            <div className="col-12 col-md-10">
              <div className="d-flex flex-wrap align-items-center">
                {/* Student Select */}
                <div className="form-group mb-2 me-2">
                  <select
                    className="form-select form-select-sm center_list"
                    style={{ minWidth: "150px" }}
                    name="studentId"
                    onChange={handleFilterChange}
                    value={filters.studentId}
                  >
                    <option value="" disabled>
                      Select a Student
                    </option>
                    {studentData?.map((student) => (
                      <option key={student.id} value={student.id}>
                        {student.studentNames}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Payment Date */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="date"
                    name="paymentDate"
                    onChange={handleFilterChange}
                    value={filters.paymentDate}
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Paid Amount */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="text"
                    name="paidAmount"
                    onChange={handleFilterChange}
                    value={filters.paidAmount}
                    onInput={(e) =>
                      (e.target.value = e.target.value.replace(/[^0-9]/g, ""))
                    }
                    placeholder="Paid Amount"
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Name */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="text"
                    name="name"
                    onChange={handleFilterChange}
                    value={filters.name}
                    placeholder="Name"
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Month */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="month"
                    name="month"
                    onChange={handleFilterChange}
                    value={filters.month}
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Invoice No */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="text"
                    name="invoiceNo"
                    onChange={handleFilterChange}
                    value={filters.invoiceNo}
                    placeholder="Invoice No"
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Receipt No */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="text"
                    name="receiptNo"
                    onChange={handleFilterChange}
                    value={filters.receiptNo}
                    placeholder="Receipt No"
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Status */}
                <div className="form-group mb-2 me-2">
                  <select
                    className="form-select form-select-sm center_list"
                    name="status"
                    onChange={handleFilterChange}
                    value={filters.status}
                    style={{ minWidth: "150px" }}
                  >
                    <option value="" disabled>
                      Select Status
                    </option>
                    <option value="PAID">Paid</option>
                    <option value="CANCELLED">Cancelled</option>
                  </select>
                </div>

                {/* Payment Method */}
                <div className="form-group mb-2 me-2">
                  <select
                    className="form-select form-select-sm center_list"
                    name="paymentMethod"
                    onChange={handleFilterChange}
                    value={filters.paymentMethod}
                    style={{ minWidth: "150px" }}
                  >
                    <option value="" disabled>
                      Select Payment Method
                    </option>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Online">Online</option>
                  </select>
                </div>

                {/* Payment Ref */}
                <div className="form-group mb-2 me-2">
                  <input
                    className="form-control form-control-sm center_list"
                    type="text"
                    name="paymentRef"
                    onChange={handleFilterChange}
                    value={filters.paymentRef}
                    placeholder="Payment Ref"
                    style={{ minWidth: "150px" }}
                  />
                </div>

                {/* Clear Filters */}
                <div className="form-group mb-2 me-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-border"
                    onClick={clearFilters}
                  >
                    Clear
                  </button>
                </div>
              </div>
            </div>
            {/* Add Button */}
            {canCreate && (
              <div className="col-12 col-md-2 d-flex justify-content-md-end justify-content-start align-items-start mt-2 mt-md-0">
                <Link to="/payment/add">
                  <button
                    type="button"
                    className="btn btn-button btn-sm"
                    style={{ fontWeight: 600 }}
                  >
                    Add <i className="bx bx-plus"></i>
                  </button>
                </Link>
              </div>
            )}
          </div>
        </div>
        {loading ? (
          <div className="loader-container">
            <div className="loading">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        ) : (
          <>
            <ThemeProvider theme={theme}>
              <MaterialReactTable table={table} />
            </ThemeProvider>

            <Menu
              id="action-menu"
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => handleStatusChange("PAID")}
                className="text-start mb-0 menuitem-style"
              >
                Paid
              </MenuItem>

              <MenuItem
                onClick={() => handleStatusChange("CANCELLED")}
                className="text-start mb-0 menuitem-style"
              >
                Canceled
              </MenuItem>
            </Menu>
          </>
        )}
      </div>
    </div>
  );
};

export default Payments;
